import React, { FunctionComponent, ReactElement } from 'react'
import cn from 'classnames'
import { Popup } from '@/components/Popup'

import styles from './TextPopup.module.scss'

interface TextPopupProps {
  className?: string
  text: string | ReactElement<any>
  title: string
  isVisible: boolean
  onClose: () => void
}
export const TextPopup: FunctionComponent<TextPopupProps> = ({
  className,
  text,
  title,
  isVisible,
  onClose,
}) => {
  if (!isVisible) {
    return null
  }

  return (
    <Popup className={cn(className, styles.container)} onClose={onClose}>
      <div className={styles.title}>{title}</div>
      <div className={styles.text}>{text}</div>
    </Popup>
  )
}
